import React from 'react';
import {Link} from 'react-router-dom';
import {getConfig} from '../support/Config';
import {ShirtIcon} from './icons';

/**
 * Бренд-блок шелла: значок и название приложения в шапке сайдбара и мобильной шторки.
 *
 * <p>Это ссылка на главную (CTHS-312/322). Логотип — привычная «кнопка домой» в любом
 * веб-приложении; раньше он был `div` с `window.location.href`, то есть ни ссылкой для
 * клавиатуры и скринридера, ни клиентской навигацией: браузер перезагружал приложение
 * целиком и терял состояние.</p>
 */
export default function Logo({collapsed = false, onNavigated}: {
    /** Свёрнутый сайдбар: остаётся только значок, название уходит в подпись ссылки. */
    collapsed?: boolean;
    /** Мобильная шторка закрывает себя после перехода. */
    onNavigated?: () => void;
}) {
    const name = getConfig('appName');
    return (
        <Link
            to="/home"
            onClick={onNavigated}
            data-testid="app-logo"
            aria-label={collapsed ? `${name} — на главную` : undefined}
            className="flex items-center gap-3 px-4 h-16 border-b border-white/5 shrink-0
                       hover:bg-white/5 transition-colors duration-ui ease-out
                       focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
        >
            <div className="w-9 h-9 rounded-xl bg-brand-500 flex items-center justify-center shrink-0">
                <ShirtIcon className="w-5 h-5 text-white"/>
            </div>
            {!collapsed && (
                <div className="min-w-0">
                    <div className="font-semibold leading-tight truncate text-white">{name}</div>
                    <div className="text-[11px] text-gray-500 truncate">Каталог гардероба</div>
                </div>
            )}
        </Link>
    );
}
